import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import login from '@/views/login/login'
import register from '@/views/login/register'
import forget from '@/views/login/forget'
import selectRegister from '@/views/login/select_register'
import city from '@/views/classify/city'
// import cityList from '@/views/classify/cityList'
import university from '@/views/classify/university'
import researchInstitute from '@/views/classify/researchInstitute'
import search from '@/views/classify/search.vue'
import famousCom from '@/views/classify/famousCom.vue'
import medicine from '@/views/classify/medicine.vue'
import Institution from '@/views/classify/Institution.vue'
import master from '@/views/classify/master.vue'
import career from '@/views/classify/career.vue'
import postdoctoral from '@/views/classify/postdoctoral.vue'
import expert from '@/views/classify/expert.vue'
import foreignProjects from '@/views/classify/foreignProjects.vue'
import returnee from '@/views/classify/returnee.vue'
import science from '@/views/classify/science.vue'
import partTime from '@/views/classify/partTime.vue'
import moreList from '@/views/classify/moreList.vue'
import intelligence from '@/views/classify/intelligence.vue'
import newPositions from '@/views/classify/newPositions.vue'
import hotPositions from '@/views/classify/hotPositions.vue'

import personalCenter from '@/views/userCenter/personalCenter'
import unCertification from '@/views/companyRegister/unCertification'
import setCompany from '@/views/companyRegister/setCompany'
import identityReview from '@/views/companyRegister/identityReview'
import companyCertification from '@/views/companyRegister/companyCertification'
import postJob from '@/views/companyRegister/postJob'
import preview from '@/views/companyRegister/preview'
import aboutUs from '@/views/about/aboutUs'
import contactUs from '@/views/about/contactUs.vue'
import recruitment from '@/views/about/recruitment.vue'
import advertisingServices from '@/views/about/advertisingServices.vue'
import disclaimer from '@/views/about/disclaimer.vue'


import jobdetail from '@/views/job/jobDetail.vue'
import positionsDetail from '@/views/companyRegister/positionsDetail.vue'
// import medicine from '@/views/job/medicine.vue'

// positionsDetail intelligence.vue
// import footer from '@/components/common/footer'
// import ckeditor from '@/components/common/ckeditor.vue'

Vue.use(Router)


const routes = [
  { path: '/login', component: login },
  { path: '/register', component: register },
  { path: '/forget', component: forget },

  // {path:'/ckeditor',component:ckeditor},

  { path: '/selectRegister', component: selectRegister },
  { path: '/city', component: city },
  // {path:'/cityList',component:cityList},
  { path: '/university', component: university },//高等院校
  { path: '/researchInstitute', component: researchInstitute },//科研院校
  { path: '/medicine', component: medicine },//医药卫生

  { path: '/famousCom', component: famousCom },//知名企业
  { path: '/Institution', component: Institution },//事业单位
  { path: '/master', component: master },//硕博热招
  { path: '/career', component: career },//职业情报
  { path: '/postdoctoral', component: postdoctoral },//博后
  { path: '/expert', component: expert },//专家
  { path: '/foreignProjects', component: foreignProjects },//国外
  { path: '/returnee', component: returnee },//海归
  { path: '/science', component: science },//科创
  { path: '/partTime', component: partTime },//社会兼职
  { path: '/moreList', component: moreList },
  { path: '/intelligence', component: intelligence },//职场要闻
  { path: '/newPositions', component: newPositions },//最新职位
  { path: '/hotPositions', component: hotPositions },//求职热点

  { path: '/aboutUs', component: aboutUs },//关于我们
  { path: '/contactUs', component: contactUs },//联系我们
  { path: '/recruitment', component: recruitment },//人才招聘
  { path: '/advertisingServices', component: advertisingServices },//广告服务
  { path: '/disclaimer', component: disclaimer },//免责声明

  { path: '/search', component: search },
  { path: '/personalCenter', component: personalCenter },
  { path: '/unCertification', component: unCertification },  //立即完成招聘者身份审核
  { path: '/setCompany', component: setCompany },  //公司主页设置
  { path: '/identityReview', component: identityReview },  //招聘者身份审核
  { path: '/companyCerter', component: companyCertification },  //招聘者身份审核
  { path: '/postJob', component: postJob },  //发布招聘
  { path: '/jobdetail', component: jobdetail },
  { path: '/preview', component: preview },
  { path: '/preview', component: preview },
  { path: '/positionsDetail', component: positionsDetail },
  { path: "*", component: index },
]
const router = new Router({
  mode: 'history',
  routes,
  scrollBehavior(to, from, savedPosition) { //跳转下一页回到顶部
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js